// 3. src/pages/attendance/TimesheetApprovalPage.jsx
import React from "react";
import TimesheetApproval from "../../components/features/attendance/TimesheetApproval";

const TimesheetApprovalPage = () => {
  return <TimesheetApproval />;
};

export default TimesheetApprovalPage;
